
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/index-home",
      function () {
        return require("private-next-pages/index-home/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/index-home"])
      });
    }
  